module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-5.6bcaefb1.png";